import React from 'react';
import { ForgotPasswordScreenDesktop } from './ForgotPasswordScreenDesktop';
import { ForgotPasswordScreenMobile } from './ForgotPasswordScreenMobile';

export const ForgotPasswordScreen = () => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <ForgotPasswordScreenMobile /> : <ForgotPasswordScreenDesktop />;
};